export default __webpack_public_path__ + "static/media/title.24afc4ac.svg";